import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CloseIcon from '../icons/Close';

import styles from '../../../styles/buttons/burger.scss';

const propTypes = {
    onClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    isActive: false,
    color: null,
    className: null,
};

const Close = ({ onClick, isActive, color, className }) => (
    <div className={classNames([styles.container, { [className]: className !== null }])}>
        <button
            className={classNames([styles.burger, { [styles.isActive]: isActive }])}
            type="button"
            onClick={onClick}
        >
            <CloseIcon color={color} />
        </button>
    </div>
);

Close.propTypes = propTypes;
Close.defaultProps = defaultProps;

export default Close;
